module.exports = __webpack_public_path__ + "img/home_five_bg.87fe3e43.png";